// extracted by mini-css-extract-plugin
export default {"clickArea":"fouUnwcHS1a"};